import BaseColors from '@/atoms/colors/Base';
import CardColors from '@/atoms/colors/Card';
import Shadow from '@/atoms/colors/Shadow';
import { brand, core } from '@/lib/theme/tokens/palettes';

const ModalColors = Object.freeze({
  primary: {
    boxShadow: `${Shadow.high}, 0 0 0 1px ${CardColors.outline.borderColor}`,
    color: BaseColors.font.primary,
  },
  secondary: {
    backgroundColor: brand.lightBlue.tints[3],
    boxShadow: `${Shadow.low}, 0 0 0 1px ${brand.lightBlue.tints[5]}`,
    color: BaseColors.font.primary,
  },
  tertiary: {
    backgroundColor: brand.blue.main,
    boxShadow: `${Shadow.low}, 0 0 0 1px ${brand.blue}`,
    color: core.white,
  },
});

export default ModalColors;
